import { render, staticRenderFns } from "./AssignmentPerformanceLesson.vue?vue&type=template&id=4afa1004&scoped=true&"
import script from "./AssignmentPerformanceLesson.vue?vue&type=script&lang=js&"
export * from "./AssignmentPerformanceLesson.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPerformanceLesson.vue?vue&type=style&index=0&id=4afa1004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa1004",
  null
  
)

export default component.exports